<template>
  <div class="row">
    <div>Total MCQs: {{ maxLength }}</div>
    <button
      v-if="currentIndex !== 0"
      class="button-black"
      @click="goToPreviousQuestion"
    >
      Previous
    </button>
    <button
      v-if="currentIndex !== maxLength - 1"
      class="button-black"
      @click="goToNextQuestion"
    >
      Next
    </button>

    <div class="small-12 columns">
      <div class="stitched-mcq-editor-main-container">
        <input
          v-model="questions.list.questions[currentIndex].title"
          class="mcq-question-title-container"
        />

        <div>
          <div
            v-for="option in questions.list.questions[currentIndex].options"
            :key="`${JSON.stringify(option)}`"
            :class="applyClassesToOptions(option)"
          >
            <vue-markdown
              :source="decodeAndRenderMarkdown(option.item, option.attachments)"
            />
            <button @click="selectOption(option)">Mark/Unmark answer</button>
          </div>
        </div>
      </div>
      <div><button @click="editQuestion">Edit</button></div>
    </div>
  </div>
</template>

<script>
// import markdownEditor from "@/components/questions/MarkdownReadingEditor"
import VueMarkdown from "vue-markdown"
import siteConfig from "@/utils/siteConfig"

export default {
  components: {
    VueMarkdown,
    // markdownEditor
  },
  data() {
    return {
      questions: [],
      question: {},
      currentIndex: 0,
      maxLength: 0,
      selectedOptions: [],
    }
  },
  mounted() {
    this.getQuestionData()
  },
  methods: {
    editQuestion() {},
    applyClassesToOptions(option) {
      const { id } = option
      const classes = ["markdown-body", "mcq-stitched-option-container"]
      if (this.checkIfArrayPartofAnswers(id)) {
        classes.push("mcq-stitched-option-selected")
      }
      return classes.join(" ")
    },
    removeOptionFromSelectedOptions(optionID) {
      const index = this.selectedOptions.indexOf(optionID)
      if (index > -1) {
        this.selectedOptions.splice(index, 1)
      }
    },
    selectOption(option) {
      if (this.checkIfArrayPartofAnswers(option.id)) {
        this.removeOptionFromSelectedOptions(option.id)
      } else {
        this.selectedOptions.push(option.id)
      }
    },
    checkIfArrayPartofAnswers(element) {
      for (let i = 0; i < this.selectedOptions.length; i++) {
        if (this.selectedOptions[i] === element) {
          return true
        }
      }
      return false
    },
    goToPreviousQuestion() {
      this.selectedOptions = []
      if (this.currentIndex > 0) {
        this.currentIndex--
      }
    },
    goToNextQuestion() {
      this.selectedOptions = []
      if (this.currentIndex < this.maxLength - 1) {
        this.currentIndex++
      }
    },
    decodeAndRenderMarkdown(content, attachments) {
      window.Prism.highlightAll()
      this.$nextTick(() => {
        window.Prism.highlightAll()
      })

      return content.replace(/(\[\[.*?\]\])/g, item => {
        for (let i = 0; i < attachments.length; i++) {
          if (attachments[i].id === item.slice(2, item.length - 2)) {
            return ` ![](${attachments[i].public_url})`
          }
        }
        return ""
      })
    },
    getQuestionData() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}questions/${this.$route.params.id}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        this.questions = res.data.data
        this.question = res.data.data
        this.maxLength = this.questions.list.questions.length
      })
    },
  },
}
</script>

<style>
.mcq-stitched-option-selected {
  border-left: 16px solid #82ff82 !important;
}
.mcq-stitched-option-container {
  margin-bottom: 8px;
  padding: 10px;
  padding-left: 20px;
  border: 1px solid grey;
  border-left: 16px solid transparent;
  font-family: "Gudea", sans-serif;
}
.mcq-question-title-container {
  padding: 20px;
  color: #03a9f4;
  font-family: "Gudea", sans-serif;
  font-size: 1.4em;
  text-align: left;
}
.stitched-mcq-editor-main-container {
  width: 800px;
  margin: auto;
  margin-top: 40px;
  padding: 40px;
  border: 1px solid black;
}
</style>
